// @ts-nocheck
/**
 * ドラフトシステム - ロビー画面
 */

import React, { useState } from 'react';
import { DRAFT_CONFIG } from '../constants';
import { draftStyles } from './styles/draftStyles';

/**
 * ドラフトロビー
 * @param {Object} props
 * @param {Function} props.onStartNew - 新規開始コールバック
 * @param {Function} props.onResume - 再開コールバック
 * @param {Function} props.onBack - 戻るコールバック
 * @param {boolean} props.hasSavedSession - 保存セッションの有無
 * @param {Object} props.savedSummary - 保存セッションのサマリー
 */
export const DraftLobby = ({
  onStartNew,
  onResume,
  onBack,
  hasSavedSession = false,
  savedSummary = null,
}) => {
  const [selectedPlayerCount, setSelectedPlayerCount] = useState(DRAFT_CONFIG.DEFAULT_PLAYER_COUNT);
  const [showResumeConfirm, setShowResumeConfirm] = useState(false);

  // 新規開始
  const handleStartNew = () => {
    if (hasSavedSession) {
      setShowResumeConfirm(true);
    } else {
      onStartNew?.(selectedPlayerCount);
    }
  };

  // 保存セッションを破棄して新規開始
  const handleDiscardAndStart = () => {
    setShowResumeConfirm(false);
    onStartNew?.(selectedPlayerCount);
  };

  // 再開
  const handleResume = () => {
    setShowResumeConfirm(false);
    onResume?.();
  };

  return (
    <div style={draftStyles.lobbyContainer}>
      {/* ヘッダー */}
      <div style={draftStyles.lobbyHeader}>
        <h1 style={draftStyles.lobbyTitle}>ブースタードラフト</h1>
        <p style={draftStyles.lobbySubtitle}>
          カードパックを開封し、他のプレイヤーと回しながらデッキを構築しよう
        </p>
      </div>

      {/* メインコンテンツ */}
      <div style={draftStyles.lobbyContent}>
        {/* ルール説明 */}
        <div style={draftStyles.rulesSection}>
          <h2 style={draftStyles.sectionTitle}>ルール</h2>
          <ul style={draftStyles.rulesList}>
            <li>各プレイヤーは{DRAFT_CONFIG.PACK_SIZE}枚のパックを受け取ります</li>
            <li>パックから1枚選んで残りを隣のプレイヤーに渡します</li>
            <li>これを繰り返してカードプールを構築します</li>
            <li>最後にカードプールから{DRAFT_CONFIG.MIN_DECK_SIZE}〜{DRAFT_CONFIG.MAX_DECK_SIZE}枚のデッキを組みます</li>
            <li>構築したデッキでトーナメントを行います</li>
          </ul>
        </div>

        {/* 参加人数選択 */}
        <div style={draftStyles.playerCountSection}>
          <h2 style={draftStyles.sectionTitle}>参加人数</h2>
          <div style={draftStyles.playerCountButtons}>
            {DRAFT_CONFIG.PLAYER_COUNT_OPTIONS.map(count => (
              <button
                key={count}
                onClick={() => setSelectedPlayerCount(count)}
                style={{
                  ...draftStyles.playerCountButton,
                  ...(selectedPlayerCount === count ? draftStyles.playerCountButtonActive : {}),
                }}
              >
                {count}人
              </button>
            ))}
          </div>
          <p style={draftStyles.playerCountInfo}>
            パック数: {DRAFT_CONFIG.PACKS_BY_PLAYER_COUNT[selectedPlayerCount]}パック/人 × {selectedPlayerCount}人
          </p>
        </div>

        {/* 保存セッション情報 */}
        {hasSavedSession && savedSummary && (
          <div style={draftStyles.savedSessionSection}>
            <h2 style={draftStyles.sectionTitle}>保存されたセッション</h2>
            <div style={draftStyles.savedSessionInfo}>
              <p>進捗: {savedSummary.progress}</p>
              <p>パック: {savedSummary.currentPack} / ラウンド: {savedSummary.currentRound}</p>
              <p>ピック済み: {savedSummary.totalPicks}枚</p>
              <p style={draftStyles.savedSessionDate}>
                保存日時: {new Date(savedSummary.savedAt).toLocaleString('ja-JP')}
              </p>
            </div>
          </div>
        )}

        {/* アクションボタン */}
        <div style={draftStyles.actionButtons}>
          {hasSavedSession && (
            <button
              onClick={handleResume}
              style={draftStyles.resumeButton}
            >
              続きから再開
            </button>
          )}
          <button
            onClick={handleStartNew}
            style={draftStyles.startButton}
          >
            新規ドラフト開始
          </button>
          <button
            onClick={onBack}
            style={draftStyles.backButton}
          >
            戻る
          </button>
        </div>
      </div>

      {/* 確認ダイアログ */}
      {showResumeConfirm && (
        <div style={draftStyles.modalOverlay}>
          <div style={draftStyles.modalContent}>
            <h3 style={draftStyles.modalTitle}>保存データがあります</h3>
            <p style={draftStyles.modalText}>
              保存されたドラフトセッションがあります。<br />
              新規開始すると保存データは削除されます。
            </p>
            <div style={draftStyles.modalButtons}>
              <button
                onClick={handleResume}
                style={draftStyles.resumeButton}
              >
                続きから再開
              </button>
              <button
                onClick={handleDiscardAndStart}
                style={draftStyles.discardButton}
              >
                破棄して新規開始
              </button>
              <button
                onClick={() => setShowResumeConfirm(false)}
                style={draftStyles.cancelButton}
              >
                キャンセル
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DraftLobby;
